import { BlockLabels } from "../scene-blocks/block-constants";

export interface ISliderBlock {
    label: string;
    icon: string;
    type: string;
    component: any;
}

export const SliderTextBlocks: ISliderBlock[] = [
    {
        label: 'H1',
        icon: 'text_fields',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "Heading 1"
            ],
            Font: [
                {
                    $: {
                        fontSize: '80',
                        fontColor: '16777215',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    },
    {
        label: 'H2',
        icon: 'text_fields',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "Heading 2"
            ],
            Font: [
                {
                    $: {
                        fontSize: '60',
                        fontColor: '16777215',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    },
    {
        label: 'H3',
        icon: 'text_fields',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "Heading 3"
            ],
            Font: [
                {
                    $: {
                        fontSize: '40',
                        fontColor: '16777215',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    },
    {
        label: 'Paragraph',
        icon: 'subject',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "This is a sample paragraph. You can edit this text to add your own content."
            ],
            Font: [
                {
                    $: {
                        fontSize: '30',
                        fontColor: '16777215',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    },
    {
        label: 'Quote',
        icon: 'format_quote',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "This is a sample quote. You can edit this text to add your own content."
            ],
            Font: [
                {
                    $: {
                        fontSize: '30',
                        fontColor: '16777215',
                        fontFamily: 'Arial Italic',
                        fontWeight: 'normal',
                        fontStyle: 'italic',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    },
    {
        label: 'Code',
        icon: 'code',
        type: BlockLabels.LABEL.id,
        component: {
            Text: [
                "console.log('Hello, world!');"
            ],
            Font: [
                {
                    $: {
                        fontSize: '30',
                        fontColor: '16777215',
                        fontFamily: 'Courier New',
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textDecoration: 'none',
                        textAlign: 'center',
                        alignSelf: 'center',
                        autoScaling: '1',
                        wrap: '1'
                    }
                }
            ]
        }
    }
];

export const SliderImageBlocks: ISliderBlock[] = [
    {
        label: 'Image',
        icon: 'image',
        type: BlockLabels.IMAGE.id,
        component: BlockLabels.IMAGE.template,
    }
];

export const SliderVideoBlocks: ISliderBlock[] = [
    {
        label: 'Video',
        icon: 'videocam',
        type: BlockLabels.VIDEO.id,
        component: BlockLabels.VIDEO.template,
    }
];
export const SliderGridBlocks = ['Grid', 'Flexbox', 'Columns', 'Rows', 'Frames', 'Sections'];
export const SliderNewFeatureBlocks = ['Feature 1', 'Feature 2', 'Feature 3'];